export default {"src":"/_next/static/media/medical.5103d37c.svg","height":1080,"width":2080};